import { render, staticRenderFns } from "./createPostWork.vue?vue&type=template&id=46fd132a&"
import script from "./createPostWork.vue?vue&type=script&lang=js&"
export * from "./createPostWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports